import React from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import { Typography } from '@material-ui/core'
import { CoreButton } from 'src/components/core'
const UpgradeCollaborationBanner = ({ classes }) => {
  return (
    <div className={classes.certificationContainer}>
      <div className={classes.content}>
        <div className={classes.bannerContainer}>
          <div className={classes.bannerContent}>
            <Typography className={classes.bannerText}>
              Want to collaborate for creating courses?
            </Typography>
            <Typography className={classes.bannerSubText}>
              Upgrade to invite collaborators to create courses and
              collections. Your collaborators don't need paid plans to
              contribute to your content.
            </Typography>
            <CoreButton
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                window.location.href = '/pricing'
              }}
            >
              See Plans & Upgrade
            </CoreButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(UpgradeCollaborationBanner)
